import { faMegaphone } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@material-ui/core";
import * as Sentry from "@sentry/react";
import React, { FC, useEffect, useRef, useState } from "react";

const ToggleFeedbackButton: FC = () => {
    const [feedback, ] = useState(() => Sentry.getFeedback());
    const buttonRef = useRef<HTMLAnchorElement>();

    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(
                buttonRef.current, {}
            );
            return () => {
                unsubscribe?.()
            }
        }

        return;
    }, [buttonRef, feedback]);

    return (
        <Tooltip 
            title="Report a Bug"
        >
            <IconButton
                aria-label="theme"
                color="inherit"
                ref={buttonRef as any}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
}

export default ToggleFeedbackButton;